const isNumber = (num) => typeof num === "number";

module.exports = { isNumber }